module.exports = __webpack_public_path__ + "img/p9.9972e6df.png";